import 'greensock';

import './modules/barba';
import './modules/lenis';
import './modules/servicesScrollTo';
import './components/collapse/collapse';
import './components/btn/burgerMenu';
